'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const universal_color = require('../../style/universal.color.js');

var mlbGrey2 = universal_color.mlbGrey2,
    mlbGrey4 = universal_color.mlbGrey4;
var StyledTable = styled__default.table.withConfig({
  displayName: "tablestyle__StyledTable",
  componentId: "sc-wsl6eq-0"
})(["", " font-family:", ";width:100%;padding-bottom:5px;border-collapse:collapse;overflow-x:hidden;thead{", " margin-bottom:20px;th{", " padding:", ";}}tbody{th{padding:", ";}td{padding:", ";}", " ", "}tfoot{th{padding:", ";}td{padding:", ";}", "}"], function (props) {
  return props.tableFixed ? 'table-layout: fixed;' : '';
}, function (_ref) {
  var _theme$fonts, _theme$fonts$family;

  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme;
  return (_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : (_theme$fonts$family = _theme$fonts.family) === null || _theme$fonts$family === void 0 ? void 0 : _theme$fonts$family.primary;
}, function (_ref2) {
  var dark = _ref2.dark,
      hideDividers = _ref2.hideDividers;
  return !hideDividers ? "border-bottom: 1px solid ".concat(dark ? mlbGrey4 : mlbGrey2, ";") : '';
}, function (_ref3) {
  var hideDividers = _ref3.hideDividers;
  return hideDividers ? "border-bottom: none;" : '';
}, function (_ref4) {
  var paddingConfig = _ref4.paddingConfig;
  return paddingConfig.headThPadding;
}, function (_ref5) {
  var paddingConfig = _ref5.paddingConfig;
  return paddingConfig.bodyThPadding;
}, function (_ref6) {
  var paddingConfig = _ref6.paddingConfig;
  return paddingConfig.bodyTdPadding;
}, function (_ref7) {
  var hoverRowHighlight = _ref7.hoverRowHighlight,
      highlightColor = _ref7.highlightColor;
  return hoverRowHighlight ? "\n      tr {\n        &:hover {\n          background-color: ".concat(highlightColor, ";\n          border-radius: 4px;\n          th {\n            background-color: ").concat(highlightColor, ";\n          }\n          td, th {\n            border-radius: 0px;\n            &:first-child {\n              border-top-left-radius: 4px;\n              border-bottom-left-radius: 4px;\n            }\n            &:last-child {\n              border-top-right-radius: 4px;\n              border-bottom-right-radius: 4px;\n            }\n          }\n        }\n      }\n      \n    ") : '';
}, function (_ref8) {
  var hideDividers = _ref8.hideDividers,
      tfootExists = _ref8.tfootExists;
  return !hideDividers ? "\n        &:before {\n          width: 100%;\n          content: '';\n          display: block;\n          line-height: 10px;\n          height: 5px;  \n        }\n        ".concat(tfootExists ? "&:after {\n            content: '';\n            display: block;\n            line-height: 10px;\n            height: 5px;\n          }" : '', "\n    ") : '';
}, function (_ref9) {
  var paddingConfig = _ref9.paddingConfig;
  return paddingConfig.bodyThPadding;
}, function (_ref10) {
  var paddingConfig = _ref10.paddingConfig;
  return paddingConfig.bodyTdPadding;
}, function (_ref11) {
  var dark = _ref11.dark,
      hideDividers = _ref11.hideDividers;
  return !hideDividers ? "border-top: 1px solid ".concat(dark ? mlbGrey4 : mlbGrey2, ";") : '';
});
var TableScroller = styled__default.div.withConfig({
  displayName: "tablestyle__TableScroller",
  componentId: "sc-wsl6eq-1"
})(["overflow-x:auto;overflow-y:hidden;box-sizing:border-box;width:", ";display:inline-block;margin-right:", ";margin-left:", ";"], function (props) {
  return "calc(".concat(props.divWidth, " - ").concat(props.leftPadding, " - ").concat(props.rightPadding, ")");
}, function (props) {
  return props.rightPadding;
}, function (_ref12) {
  var leftPadding = _ref12.leftPadding;
  return leftPadding;
});
var TableContainer = styled__default.div.withConfig({
  displayName: "tablestyle__TableContainer",
  componentId: "sc-wsl6eq-2"
})(["width:", ";max-width:", ";position:relative;display:inline-block;overflow:hidden;"], function (_ref13) {
  var containerWidth = _ref13.containerWidth;
  return containerWidth;
}, function (_ref14) {
  var containerMaxWidth = _ref14.containerMaxWidth;
  return containerMaxWidth;
});

exports.StyledTable = StyledTable;
exports.TableContainer = TableContainer;
exports.TableScroller = TableScroller;
